define('views/modules/template/list/template-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    // services
    'services/i18n',
    'services/events/template-events',
    //models
    'models/template/template',
    // views
    'views/modules/template/edit/calendar/calendar-component/template-calendar',
    'views/parts/media-info-box',
], function(
    // Libs
    _, Backbone, Mustache, moment, Bootbox, U,
    // services
    i18n,
    TemplateEvents,
    //models
    MTemplate,
    // views
    VTemplateCalendar,
    VMediaInfoBox
) {

    var VTemplateListItem = Backbone.View.extend({
        className: 'template-list-item',

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                profile: opt.profile,
                group: opt.group
            });

            var model = this.model,
                view = this.view = {
                    infobox: new VMediaInfoBox({
                        title: 'name',
                        subtitle: 'description',
                        model: model,
                        context: this,
                        onClick: this.onClick,
                        menu: {
                            init: this.onMenuInit,
                            onClick: this.onActionClick,
                        }
                    }),
                };

            this.setUrl('assign', Mustache.render('#/supervisor/group/{{{groupId}}}/member/{{{userId}}}/calendar/{{dayId}}/template/assign/', {
                groupId: this.group.id,
                userId: this.profile.id,
                dayId: moment().format('YYYY-MM-DD')
            }));

            this.listenTo(model, { 'remove': this.remove });
            this.listenTo(model, { 'setItemActive': this.setActive.bind(this, true) });
        },
        render: function() {
            this.assign(this.view.infobox, this.$el);
            return this;
        },

        deleteTemplate: function(result) {
            if (result) {
                this.model.destroy();
            }
        },

        setActive: function(val) {
            this.$el.toggleClass('active', val);
        },

        isActive: function() {
            return this.$el.hasClass('active');
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            this.onEditAction();
        },

        onActionClick: function(e, item) {
            if (!item.has('route')) e.preventDefault();
        },

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Edit', icon: "sl-icon-note", callback: this.onEditAction },
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction },
                { caption: 'Duplicate', icon: "sl-icon-docs", callback: this.onDuplicateAction },
                //{ route: this.url.assign, caption: 'Assign', icon: 'sl-icon-organization' },
                { caption: i18n.t('menu:Assign'), icon: 'sl-icon-organization', callback: this.onDisplayAssignmentPanelAction }
            ]);
        },

        onEditAction: function() {
            var model = this.model;
            model.trigger('template:edit', model);
            this.setActive(true);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete template"),
                message: i18n.t("messages:message-delete-template"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteTemplate,
                context: this,
            });
        },

        onDuplicateAction: function() {
          var model = this.model;
          model.trigger('template:duplicate', model);
          this.setActive(true);
        },

        onDisplayAssignmentPanelAction: function() {
          var model = this.model;
          model.trigger('template:displayAssignment', model);
          this.setActive(true);
        },

    });

    return VTemplateListItem;

});

